import React from "react";
import { Link } from "react-router-dom";
import { SearchBar } from "@features/search/ui/SearchBar";
import { NAVIGATION_ITEMS } from "@shared/config/navigation";
import { HashLink } from 'react-router-hash-link';

const Footer: React.FC = () => {

  const scrollWithOffset = (el: HTMLElement) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; // Здесь можно настроить смещение (например, высота фиксированного хедера)
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  };
  return (
    <footer className="flex flex-col items-center w-full bg-yellow-400 py-4 min-h-[100px] justify-center">
      <div className="flex flex-col items-center container md:flex-row md:justify-between">
        {/* Логотип */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/d1539f68f51c7c8931b55d7cc7400f95ee2926a1901e97c21a8bd733ecce5b7d?apiKey=e11f1c3e4c454432a22c0ca424050c32&"
            alt="Company Logo"
            className="object-contain h-10 w-[120px] sm:h-11 sm:w-[147px] mb-4 md:mb-0"
          />
        </Link>
        {/* Навигация */}
        <nav className="flex flex-wrap justify-center gap-4 md:gap-6 items-center mb-4 md:mb-0">
          <HashLink smooth to="/#about-huter" scroll={el => scrollWithOffset(el)} className="text-[21px] cursor-pointer font-bold hover:text-white transition-colors">
            About us
          </HashLink>
          {NAVIGATION_ITEMS.map((item) => (
            <Link
              key={item.id}
              to={item.path}
              className="text-[21px] cursor-pointer font-bold hover:text-white transition-colors"
            >
              {item.label}
            </Link>
          ))}
          <HashLink smooth to="/#contacts" scroll={el => scrollWithOffset(el)} className="text-[21px] cursor-pointer font-bold hover:text-white transition-colors">
            Contacts
          </HashLink>
        </nav>
        {/* Поисковая строка */}
        <div className="flex flex-col items-center md:items-end w-full sm:w-auto">
          <SearchBar />
        </div>
      </div>
    </footer>
  );
};

export default Footer;